"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var useRoute_1 = __importDefault(require("@/Hooks/useRoute"));
var AppLayout_1 = __importDefault(require("@/Layouts/AppLayout"));
var react_i18next_1 = require("react-i18next");
var q_play_components_1 = require("@nordicscreen/q-play-components");
var Tab_1 = __importDefault(require("@/Components/common/Tab"));
var InviteMember_1 = __importDefault(require("./InviteMember"));
var usersList_1 = __importDefault(require("./usersList"));
var inertia_1 = require("@inertiajs/inertia");
var MembersList_module_css_1 = __importDefault(require("./MembersList.module.css"));
function Users() {
    var route = (0, useRoute_1.default)();
    var t = (0, react_i18next_1.useTranslation)("translation", { useSuspense: true }).t;
    var _a = (0, q_play_components_1.useModal)(), isShown = _a.isShown, toggle = _a.toggle;
    return (react_1.default.createElement(AppLayout_1.default, { title: "Users & Teams", renderHeader: function () { return (react_1.default.createElement("h2", { className: "header" }, t("Users & Teams"))); } },
        react_1.default.createElement("div", { className: MembersList_module_css_1.default.tabsContainer },
            react_1.default.createElement("div", { className: MembersList_module_css_1.default.topButtonsContainer },
                react_1.default.createElement(q_play_components_1.Button, { text: t("Invite member"), onClick: toggle, className: MembersList_module_css_1.default.inviteMemberButton }),
                react_1.default.createElement(Tab_1.default, { value: "users", text: t("Users"), active: true, className: "me-4", variant: "secondary" }),
                react_1.default.createElement(Tab_1.default, { value: "invitedEmails", text: t("Invited emails"), onClick: function () { return inertia_1.Inertia.visit(route("team.invitations")); }, active: false, variant: "primary" }),
                react_1.default.createElement(Tab_1.default, { value: "teams", text: t("Teams"), active: false, onClick: function () { return inertia_1.Inertia.visit(route("team.list")); }, className: "ms-4", variant: "primary" })),
            react_1.default.createElement(usersList_1.default, null)),
        react_1.default.createElement(InviteMember_1.default, { modal: { isShown: isShown, toggle: toggle } })));
}
exports.default = Users;
